import { Injectable } from '@angular/core';
import { PlayerServiceCollection, PlayerServiceCollectionAction, PlayerServiceWsDTO } from './player-ws.model';
import { AbstractWsService } from '../abstract-ws.service';
import { DuplicateCheckDTO } from '../../../../feature/manage/player/duplicate-checks/duplicate-checks.dto';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import {
  DuplicateCheck,
  DuplicateCheckUnlock,
} from '../../../../feature/manage/player/duplicate-checks/duplicate-checks.model';
import {
  DocumentRequestCreatedDTO,
  DocumentRequestDTO,
  DocumentRequestStatusChangedDTO,
} from '../../../../feature/manage/player/documents/documents.model';

@Injectable({
  providedIn: 'root',
})
export class PlayerWsService extends AbstractWsService<PlayerServiceWsDTO> {
  private readonly duplicateCheckCreatedSubject = new ReplaySubject<DuplicateCheckDTO>(1);
  private readonly duplicateCheckLockedSubject = new ReplaySubject<any>(1);
  private readonly duplicateCheckUnlockedSubject = new ReplaySubject<DuplicateCheckUnlock>(1);
  private readonly duplicateCheckArchivedSubject = new ReplaySubject<DuplicateCheck>(1);

  private readonly docReqUpdatedSubject = new ReplaySubject<DocumentRequestDTO>(1);
  private readonly docReqStatusUpdatedSubject = new BehaviorSubject<DocumentRequestStatusChangedDTO>(undefined);
  private readonly docReqCreatedSubject = new ReplaySubject<DocumentRequestCreatedDTO>(1);

  protected getPath(): string {
    return '/player/admin-ws';
  }
  protected onError(error: any): void {
    console.error('[PLAYER WS] error:', error);
  }

  constructor() {
    super();
    this.subscribeToMessages();
  }

  public duplicateCheckCreatedObservable(): Observable<DuplicateCheckDTO> {
    return this.duplicateCheckCreatedSubject.asObservable();
  }

  public duplicateCheckLockedObservable(): Observable<any> {
    return this.duplicateCheckLockedSubject.asObservable();
  }

  public duplicateCheckUnlockedObservable(): Observable<DuplicateCheckUnlock> {
    return this.duplicateCheckUnlockedSubject.asObservable();
  }

  public duplicateCheckArchivedObservable(): Observable<DuplicateCheck> {
    return this.duplicateCheckArchivedSubject.asObservable();
  }

  public docRequestStatusObservable(): Observable<DocumentRequestStatusChangedDTO> {
    return this.docReqStatusUpdatedSubject.asObservable();
  }

  public docRequestUpdatedObservable(): Observable<DocumentRequestDTO> {
    return this.docReqUpdatedSubject.asObservable();
  }

  public docRequestCreatedObservable(): Observable<DocumentRequestCreatedDTO> {
    return this.docReqCreatedSubject.asObservable();
  }

  private subscribeToMessages() {
    this.getMessagesObs().subscribe((msg) => this.handleMessage(msg));
  }

  private handleMessage(msg: PlayerServiceWsDTO) {
    switch (msg.collection) {
      case PlayerServiceCollection.DUPLICATE_CHECKS:
        this.handleDuplicateCheckMessage(msg);
        break;
      case PlayerServiceCollection.DOCUMENT_REQUESTS:
        this.handleDocumentRequestsMessage(msg);
        break;
    }
  }

  private handleDuplicateCheckMessage(msg: PlayerServiceWsDTO) {
    switch (msg.action) {
      case PlayerServiceCollectionAction.CREATED:
        this.duplicateCheckCreatedSubject.next(msg.data);
        break;
      case PlayerServiceCollectionAction.LOCKED:
        this.duplicateCheckLockedSubject.next(msg.data as any);
        break;
      case PlayerServiceCollectionAction.UNLOCKED:
        this.duplicateCheckUnlockedSubject.next(msg.data as DuplicateCheckUnlock);
        break;
      case PlayerServiceCollectionAction.ARCHIVED:
        this.duplicateCheckArchivedSubject.next(msg.data as DuplicateCheck);
        break;
    }
  }

  private handleDocumentRequestsMessage(msg: PlayerServiceWsDTO) {
    switch (msg.action) {
      case PlayerServiceCollectionAction.CREATED:
        this.docReqCreatedSubject.next(msg.data as DocumentRequestCreatedDTO);
        break;
      case PlayerServiceCollectionAction.UPDATED:
        this.docReqUpdatedSubject.next(msg.data as DocumentRequestDTO);
        break;
      case PlayerServiceCollectionAction.STATUS_CHANGED:
        this.docReqStatusUpdatedSubject.next(msg.data as DocumentRequestStatusChangedDTO);
        break;
    }
  }
}
